import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function RouteTracker() {
  const location = useLocation();
  const first = useRef(true);
  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    if (window.gtag && window.GA_MEASUREMENT_ID) {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [location]);
  return null;
}
